import * as React from 'react'

const TypeScript = () => {
  return (
    <div>
      Foo
    </div>
  )
}

export default TypeScript
